import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";

export default function AssociatedCard({
  item,
  setEditedItem,
  setOpen2,
  setSelectedUser,
}) {
  return (
    <Card
      sx={{
        cursor: "pointer",
        ":hover": {
          bgcolor: "#2892ba17",
        },
      }}
      onClick={setEditedItem}
    >
      <CardContent>
        <Grid container>
          <Grid xs={6} sx={{ display: "flex" }}>
            <Typography
              color="primary"
              sx={{
                overflow: "Hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 600,
              }}
            >
              {item?.name}
            </Typography>
          </Grid>
          <Grid xs={6} sx={{}}>
            <Typography
              onClick={(e) => {
                e.stopPropagation();
                setOpen2(true);
                setSelectedUser(item);
              }}
              color="secondary"
              sx={{
                overflow: "Hidden",
                fontSize: "12px",
                float: "right",
                cursor: "pointer",
                textOverflow: "ellipsis",
                fontWeight: 500,
              }}
            >
              Scope
            </Typography>
          </Grid>
        </Grid>

        <Grid container>
          <Grid xs={6} sx={{ display: "flex" }}>
            <Typography
              sx={{
                marginRight: "5px",
                overflow: "Hidden",
                fontSize: "12px",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 500,
              }}
            >
              User ID
            </Typography>
            <Typography
              color="primary"
              sx={{
                overflow: "Hidden",
                fontSize: "12px",
                textOverflow: "ellipsis",

                fontWeight: 500,
              }}
            >
              {item?.loginId}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              sx={{
                overflow: "Hidden",
                fontSize: "12px",
                textOverflow: "ellipsis",
                float: "right",

                fontWeight: 500,
              }}
            >
              Groups Assigned: <Box component="span" color="primary"></Box>{" "}
              {item?.groupedAssigned}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
